import { useTranslation } from 'react-i18next';
import {
  Action,
  ActionsTableMenu,
} from 'src/components/atoms/actions-table-menu';
import { usePermissions } from 'src/permissions/can';

interface Props {
  onEditName: () => void;
  onManageEmployeesGroups: () => void;
  onDelete: () => void;
}

export const SpaceGroupsActionsTableMenu = ({
  onEditName,
  onManageEmployeesGroups,
  onDelete,
}: Props) => {
  const { t } = useTranslation(['spaceGroups', 'common']);

  const permissions = usePermissions();

  const actions: Action[] = [
    {
      id: 'editName',
      label: t('spaceGroups:common.actions.editName'),
      onClick: onEditName,
      disabled: permissions.cannot('update', 'SpaceGroups'),
      tooltip: t('common:notSufficientPermissions'),
    },
    {
      id: 'manageEmployeeGroups',
      label: t('spaceGroups:common.actions.manageEmployeeGroups'),
      onClick: onManageEmployeesGroups,
      disabled: permissions.cannot('manageEmployeeGroups', 'SpaceGroups'),
      tooltip: t('common:notSufficientPermissions'),
    },
    {
      id: 'delete',
      label: t('spaceGroups:common.actions.delete'),
      onClick: onDelete,
      disabled: permissions.cannot('delete', 'SpaceGroups'),
      tooltip: t('common:notSufficientPermissions'),
    },
  ];

  return <ActionsTableMenu actions={actions} />;
};
